<template>
  <v-app>
    <v-app-bar app color="primary">
      <v-row align="center" no-gutters justify="center">
        <v-col align="center">
          <template v-if="$store.state.build_dealer_config === 'Chespik'">
            <v-toolbar-title class="text-center"
              >CHESPIK - Digital Profile Card</v-toolbar-title
            >
          </template>
          <template v-else>
            <v-toolbar-title class="text-center"
              >GlobalMediaHubli - Digital Profile Card</v-toolbar-title
            >
          </template>
        </v-col>
      </v-row>
    </v-app-bar>

    <v-content justify="center">
      <v-card width="400" class="mx-auto mt-5">
        <v-card-title>
          <h1 class="display1">Login</h1>
          <div v-if="error" class="alert alert-danger">{{ error }}</div>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field
              label="email"
              v-model="email"
              prepend-icon="mdi-user"
              type="email"
              required
            />
            <v-text-field
              label="password"
              v-model="password"
              type="password"
              prepend-icon="mdi-lock"
              required
            />
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="info"
            :disabled="!valid"
            @click="launchLogin"
            :loading="saving"
            >Login</v-btn
          >
          <v-spacer></v-spacer>
          <pre> New User  </pre>
          <v-btn color="success" @click="launchRegister">Register</v-btn>
        </v-card-actions>
      </v-card>
    </v-content>

    <v-footer dark padless color="primary lighten-1">
      <v-card tile class="primary lighten-1 white--text" width="100%">
        <v-row align="center" no-gutters justify="center">
          <v-col align="center">
            <v-card-text class="black--text pt-0">
              <span class="mr-1">Powered by</span>
              <template v-if="$store.state.build_dealer_config === 'Chespik'">
                <a href="http://www.fleetop.net" target="_blank">
                  <strong class="white--text pt-0">FleeTOP Technologies</strong>
                </a>
              </template>
              <template v-else>
                <a href="http://www.globalmediahubli.com" target="_blank">
                  <strong class="white--text pt-0">Global Media Hubli</strong>
                </a>
              </template>
            </v-card-text>
          </v-col>
        </v-row>
      </v-card>
    </v-footer>
  </v-app>
</template>
<script>
import firebase from "firebase";
export default {
  name: "Login",
  data: () => ({
    valid: true,
    email: "",
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+\..+/.test(v) || "E-mail must be valid"
    ],
    password: "",
    passwordRules: [
      v => !!v || "Password is required",
      v => (v && v.length >= 6) || "Password must be atleast 6 characters"
    ],
    error: null,
    user: { email: null, password: null },
    adminlogin: false,
    saving: false
  }),

  methods: {
    launchRegister() {
      this.$router.push({ path: "/Register" });
    },
    launchLogin() {
      if (this.$store.state.build_dealer_config === "GlobalMediaHubli") {
        if (this.email === "globalMediaHubli@fleetop.net") {
          if (this.password === "gLoBALmedia@bhd") {
            this.adminlogin = true;
          }
        }
      } else {
        if (this.email === "fleeTOPadministrator@fleetop.net") {
          if (this.password === "fleeTOP@2020bhd") {
            this.adminlogin = true;
          }
        }
      }
      this.$refs.form.validate();
      if (this.valid === true) {
        this.saving = true;
        this.error = null;
        this.user.email = this.email;
        this.user.password = this.password;
        this.$store
          .dispatch("updateloginUser", this.user)
          .then(() => {
            if (this.$store.state.user.loggedIn === false) {
              this.error = this.$store.state.error;
              this.saving = false;
            } else {
              this.error = null;
              this.$refs.form.reset();
              var user = firebase.auth().currentUser;
              if (this.adminlogin === true) {
                this.saving = false;
                this.$router.replace({ name: "Administrator" });
              } else {
                if (user.photoURL !== null && user.displayName !== null) {
                  this.saving = false;
                  this.$router.push({
                    path: "/Profile/" + user.photoURL + "/" + user.displayName
                  });
                } else {
                  this.saving = false;
                  user
                    .delete()
                    .then(() => {
                      alert(
                        "Your Profile details are not available with us..Please register again!! Thank You"
                      );
                      // User deleted.
                    })
                    .catch(err => {
                      // An error happened.
                      this.error = err.message;
                    });
                }
              }
            }
          })
          .catch(err => {
            this.error = err.message;
            this.saving = false;
          });
      }
    },
    signOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace({
            name: "home"
          });
        });
    }
  }
};
</script>
